<template>
  <div :class="[{opened: isOpened}, 'shop-window']">
    <div class="scroll-view">
      <div class="close" v-on:click="close">&times;</div>
      <div class="inner">
        <h1>Ecoepi Shop</h1>
        <p><strong>{{gold}}</strong> Gold</p>

        <div class="item-list">
          <div v-for="item in itemList" :key="'shop-item' + item.type" class="item">
            <img :src="require(`@/assets/img/units/${item.type}/default.png`)" class="item-image" />
            <h2 class="item-name">
              {{item.name}}
              <span class="item-having-count">
                所持数:
                <strong>{{seedsCount[item.type] || 0}}</strong> 個
              </span>
            </h2>

            <div class="item-actions">
              <span :class="[{ok: enoughGold(item)}, 'button']" v-on:click="buy(item)">購入: <strong>{{item.price}}Gold</strong></span>
              <span v-if="!enoughGold(item)" class="item-action-message">ゴールドが足りません</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopWindow',
  created() {
    this.$store.dispatch('updateSeedsCount');
  },
  methods: {
    close() {
      this.$store.dispatch('setUserActionMode', { mode: null });
    },
    buy(unitTemplate) {
      if (!this.enoughGold(unitTemplate)) return;
      this.$store.dispatch('buyItem', unitTemplate);
    },
    enoughGold(unitTemplate) {
      return unitTemplate.price <= this.$store.state.game.assetManager.gold;
    },
  },
  computed: {
    gold() {
      return this.$store.state.game.assetManager.gold;
    },
    isOpened() {
      return this.$store.state.userActionMode === 'shop';
    },
    itemList() {
      return this.$store.state.game.shop.itemList();
    },
    seedsCount() {
      return this.$store.state.seedsCount;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.shop-window {
  color: #fff;
  overflow-y: scroll;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 6px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  display: none;
  animation: fadeIn 0.5s;
  padding: 80px 0 20px;

  .scroll-view {
    height: 100%;
    overflow-y: scroll;
  }

  &.opened {
    display: block;
  }

  .inner {
    padding: 2em 5em;
  }

  .item-list {
    text-align: left;

    .item {
      width: 100%;

      // TODO: autoprefixer 対応
      display: -ms-grid;
      -ms-grid-rows: 4.5rem 2rem;
      -ms-grid-columns: 120px 1fr;

      display: grid;
      grid-template-rows: 4.5rem 2rem;
      grid-template-columns: 120px 1fr;

      margin-bottom: 1rem;
    }

    .item-image {
      // TODO: autoprefixer 対応
      -ms-grid-row: 1/4;
      -ms-grid-column: 1;

      grid-row: 1/4;
      grid-column: 1;

      width: 100%;
      display: block;
    }

    .item-name {
      // TODO: autoprefixer 対応
      -ms-grid-row: 1;
      -ms-grid-column: 2;

      grid-row: 1;
      grid-column: 2;

      line-height: 3rem;
      font-size: 1.5rem;
    }

    .item-description {
      // TODO: autoprefixer 対応
      -ms-grid-row: 2;
      -ms-grid-column: 2;

      grid-row: 2;
      grid-column: 2;

      line-height: 2rem;
    }

    .item-having-count {
      display: inline-block;
      margin-left: 0.5rem;
      font-size: 0.8rem;
      line-height: 2rem;
      font-weight: normal;

      strong {
        font-size: 1rem;
        font-weight: bold;
      }
    }

    .item-actions {
      // TODO: autoprefixer 対応
      -ms-grid-row: 2;
      -ms-grid-column: 2;

      grid-row: 2;
      grid-column: 2;

      .item-action-message {
        line-height: 2.5rem;
        // font-weight: bold;
        font-size: 0.8rem;
        margin-left: 0.5rem;
      }

      .button {
        background: #fff;
        color: #555;
        display: inline-block;
        line-height: 2.5rem;
        padding: 0 1rem;
        font-size: 1rem;
        border-radius: 1.5rem;
        transition: opacity 0.2s;
        cursor: not-allowed;
        opacity: 0.4;

        &.ok {
          opacity: 0.85;
          cursor: pointer;

          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .close {
    position: absolute;
    top: 0;
    left: 0;
    $size: 80px;
    font-size: $size;
    line-height: $size;
    height: $size;
    width: $size;
    padding: 0;
    cursor: pointer;
    transition: opacity 0.1s;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/ShopWindow.vue